import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import MatchPage from "./pages/Matchs";
import StatsPage from "./pages/Stats";
import FanZonePage from "./pages/FanZonePage";
import RegisterPage from "./pages/RegisterPage";
import NotFoundPage from "./pages/NotFoundPage";
import PrivateRoute from "./components/Auth/PrivateRoute";
import GaleriePage from "./pages/Galerie";
import Navbar from "./components/Layout/Navbar";
import AuthPage from "./pages/AuthPage";
import ProfilePage from "./pages/ProfilePage";
import Admin from './pages/admin/Admin';
import Matches from './pages/admin/Matches';
import Players from './pages/admin/Players';
import Gallery from './pages/admin/AdminGalerie';
import Quiz from './pages/admin/Quiz';
import Moderation from './pages/admin/Moderation';
import Stats from './pages/admin/Stats';
import Teams from './pages/admin/Teams';
import Equipes from './pages/Equipes';
import EquipeDetail from "./pages/EquipeDetail";
import Footer from './components/Layout/Footer';
import AdminStaff from './pages/admin/AdminStaff';

import AdminUsers from './pages/admin/AdminUsers';
import AdminBadges from './pages/admin/AdminBadges';
import AdminBoutique from './pages/admin/AdminBoutique';
import AdminFormeRecente from './pages/admin/AdminFormeRecente';
import Boutique from './pages/Boutique';
import MentionsLegales from './pages/MentionsLegales';
import RGPD from './pages/RGPD';
import CGU from './pages/CGU';
import FAQ from './pages/FAQ';
import Club from './pages/Club';
import Partenaires from './pages/Partenaires';
import AdminArticles from "./pages/admin/AdminArticles";
import LogoutPage from './pages/LogoutPage';

// Fan Zone components
import FanZoneDashboard from './components/FanZone/FanZoneDashboard';
import FanZoneLeaderboard from './components/FanZone/FanZoneLeaderboard';
import FanZoneProfile from './components/FanZone/FanZoneProfile';
import WordleGame from './components/FanZone/games/WordleGame';
import QuiEstCeGame from './components/FanZone/games/QuiEstCeGame';
import PuzzleGame from './components/FanZone/games/PuzzleGame';
import PronosticsGame from './components/FanZone/games/PronosticsGame';

function AppRoutes() {
  const location = useLocation();
  const hideNavbar = location.pathname.startsWith("/admin") || location.pathname === "/auth" || location.pathname === "/profile" || location.pathname === "/logout";
  const hideFooter = location.pathname.startsWith("/admin") || location.pathname === "/logout" || location.pathname.startsWith("/fanzone");
  return (
    <>
      {!hideNavbar && <Navbar />}
      <Routes>
        {/* Pages principales */}
        <Route path="/" element={<HomePage />} />
        <Route path="/matchs" element={<MatchPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/equipes" element={<Equipes />} />
        <Route path="/equipes/:slug" element={<EquipeDetail />} />
        <Route path="/boutique" element={<Boutique />} />
        <Route path="/galerie" element={<GaleriePage />} />
        <Route path="/club" element={<Club />} />
        <Route path="/partenaires" element={<Partenaires />} />

        {/* Fan Zone */}
        <Route path="/fanzone" element={<FanZonePage />} />
        <Route path="/fanzone/dashboard" element={<PrivateRoute><FanZoneDashboard /></PrivateRoute>} />
        <Route path="/fanzone/classement" element={<FanZoneLeaderboard />} />
        <Route path="/fanzone/profil" element={<PrivateRoute><FanZoneProfile /></PrivateRoute>} />
        <Route path="/fanzone/wordle" element={<PrivateRoute><WordleGame /></PrivateRoute>} />
        <Route path="/fanzone/quiEstCe" element={<PrivateRoute><QuiEstCeGame /></PrivateRoute>} />
        <Route path="/fanzone/puzzle" element={<PrivateRoute><PuzzleGame /></PrivateRoute>} />
        <Route path="/fanzone/pronostics" element={<PrivateRoute><PronosticsGame /></PrivateRoute>} />

        {/* Votes */}


        {/* Auth */}
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
        <Route path="/logout" element={<LogoutPage />} />

        {/* Admin */}
        <Route path="/admin" element={<Admin />}>
          <Route index element={<Navigate to="matches" replace />} />
          <Route path="matches" element={<Matches />} />
          <Route path="players" element={<Players />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="quiz" element={<Quiz />} />
          <Route path="moderation" element={<Moderation />} />
          <Route path="stats" element={<Stats />} />
          <Route path="teams" element={<Teams />} />
          <Route path="staff" element={<AdminStaff />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="badges" element={<AdminBadges />} />
          <Route path="boutique" element={<AdminBoutique />} />
          <Route path="forme-recente" element={<AdminFormeRecente />} />

          <Route path="articles" element={<AdminArticles />} />
        </Route>

        {/* Pages légales */}
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/rgpd" element={<RGPD />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/faq" element={<FAQ />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      {!hideFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
